export const getUserProducts = user =>
  user?.userAccess.reduce((acc, cur) => {
    acc = [...acc, ...(cur.therapeutic?.products || [])];

    if (cur.product && !acc.find(p => p.id === cur.product.id)) {
      acc.push(cur.product);
    }

    return acc;
  }, []);

/**
 *
 * @param {*} user
 * @returns user role Admin is returned in lowercase to preserve backwards compatibility
 */
export const getUserRole = user => {
  if (!user || !user.profile) return 'User'
  if (user.profile.name === 'Admin') return 'admin';
  else return user.profile.name;
}

// Those countries are determined solely by the products the user has access to.
// in DB for UserAccess table, rows with only the country filled won't be considered here, as they are only used to get all the products for a country in case of manual profile with no direct products access (mostly admins)
export const getUniqueUserCountries = user => {
  const userAccess = user.userAccess;
  //User access can have duplicate country values,
  //filtering only the unique countries
  if (!userAccess) {
    return [];
  }

  const countries = {};
  userAccess.forEach(ele => {
    const country = ele.country;
    // Guard against malformed userAccess entries (e.g. missing/null country) so a
    // bad entry can never be turned into a literal "null" id sent to the API.
    if (!country || country.id == null) {
      return;
    }
    if (!countries[country.id]) {
      countries[country.id] = { name: country.name, code: country.code };
    }
  });

  return Object.keys(countries).map(key => {
    const { name, code } = countries[key];
    return { id: key, name, code };
  });
};
